import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_STUDENTS: async (context, payload) => {
            await RepositoryFactory.get('users').get(payload).then((res) => {
                console.log(res.data)
                context.commit('SET_STUDENTS', res.data.users)
            });
        },

        GET_ATTACHMENTS: async (context, payload) => {
            await RepositoryFactory.get('users').getAttachments(payload).then((res) => {
                context.commit('SET_ATTACHMENTS', res.data.attachments)
            });
        }
    },

    mutations: {
        SET_STUDENTS: (state, payload) => {
            state.students = payload;
        },

        SET_ATTACHMENTS: (state, payload) => {
            state.attachments = payload;
        },
    },

    state: {
        students: {},
        attachments: [],
    },

    getters: {
        STUDENTS: state => {
            return state.students.data;
        },

        STUDENTS_PAGINATOR: state => {
            return {
                current: state.students.current_page,
                per_page: state.students.per_page,
                total:  state.students.last_page,
            }
        },

        ATTACHMENTS: state => {
            return state.attachments;
        },
    }
}
